module.exports = __webpack_public_path__ + "img/logo_fast.12795055.png";